import type { QueryClient } from '@tanstack/react-query';

import type { IFilterOptions as IEthanolFilterOptions } from '../services/indicators/fuelsIndicatorsEthanol/types';
import type { IFilterOptions as IDerivativesFilterOptions } from '../services/indicators/fuelsIndicatorsPetroleumDerivatives/types';
import type { IDashboardChartMetadata } from '../services/indicators/fuelsIndicatorsMarket/types';
import { queryKeys } from '../queries/queryKeys';

export function hydrateChartMetadataCache(
  queryClient: QueryClient,
  metadata: IDashboardChartMetadata
): void {
  if (metadata.ethanol) {
    queryClient.setQueryData(queryKeys.indicators.ethanol.maxDate, metadata.ethanol.maxDate);
    queryClient.setQueryData<IEthanolFilterOptions>(
      queryKeys.indicators.ethanol.filterOptions,
      metadata.ethanol.filterOptions
    );
  }

  if (metadata.derivatives) {
    queryClient.setQueryData(
      queryKeys.indicators.derivatives.maxDate,
      metadata.derivatives.maxDate
    );
    queryClient.setQueryData<IDerivativesFilterOptions>(
      queryKeys.indicators.derivatives.filterOptions,
      metadata.derivatives.filterOptions
    );
  }

  if (metadata.biodiesel) {
    queryClient.setQueryData(queryKeys.indicators.biodiesel.maxDate, metadata.biodiesel.maxDate);
  }

  if (metadata.quotes) {
    queryClient.setQueryData(queryKeys.indicators.quotes.maxDate, metadata.quotes.maxDate);
  }
}
